import React from 'react';

import resumeProfileImage from 'assets/images/pages/homepage/pharmuni-ai/resume-professional.png';
import competencyRadarImage from 'assets/images/pages/homepage/pharmuni-ai/career-competency-radar.png';
import marketBenchmarkImage from 'assets/images/pages/homepage/pharmuni-ai/Market-benchmark.png';
import jobRadarImage from 'assets/images/pages/homepage/pharmuni-ai/job-radar.png';

import classes from './PharmuniAI.module.scss';

const CARDS = [
    {
        id: 'resume-profile',
        kicker: 'Resume to Professional Profile',
        title: 'Resume to Professional Profile',
        text: 'AI helps turn your resume into a public professional profile and gives you feedback to improve how you present your skills, experience, and learning progress.',
        image: resumeProfileImage,
    },
    {
        id: 'competency-radar',
        kicker: 'Career',
        title: 'Career Competency Radar',
        text: 'AI analyzes your profile and creates a Career Competency Radar, giving you a clearer view of your strengths, gaps, and career readiness.',
        image: competencyRadarImage,
    },
    {
        id: 'market-benchmark',
        kicker: 'Resume to Professional Profile',
        title: 'Market Benchmark Comparison',
        text: 'Your radar can be compared with average job expectations across different countries, pharma roles, and skill levels, helping you understand where you stand.',
        image: marketBenchmarkImage,
    },
    {
        id: 'job-radar-matching',
        kicker: 'Career',
        title: 'Job Radar Matching',
        text: 'For each pharma job, AI creates a job-specific competency radar and compares it with yours, so you can see how well you match and what to improve next.',
        image: jobRadarImage,
    },
];

const PharmuniAI = () => {
    return (
        <div className='container'>
            <section className={classes['pharmuni-ai']}>
                <div className={classes['pharmuni-ai__head']}>
                    <h2>                        
                        <span className={classes['pharmuni-ai__brand']}>Pharmuni AI:</span> Intelligent Career Guidance for Pharma Professionals
                    </h2>
                    <p>
                        Pharmuni uses AI to transform your resume, skills, and goals into actionable career insights —
                        helping you strengthen your profile, assess your readiness, and discover better-fit pharma opportunities.
                    </p>
                </div>

                <div className={classes['pharmuni-ai__grid']}>
                    {CARDS.map(({ id, kicker, title, text, image }) => (
                        <article key={id} className={classes['pharmuni-ai__card']}>
                            <span className={classes['pharmuni-ai__kicker']}>{kicker}</span>
                            <h3 className={classes['pharmuni-ai__title']}>{title}</h3>
                            <p className={classes['pharmuni-ai__text']}>{text}</p>

                            <div className={classes['pharmuni-ai__media']}>
                                {image ? (
                                    <img src={image.src} alt={title} />
                                ) : (
                                    <span className={classes['pharmuni-ai__media-placeholder']}>Image coming soon</span>
                                )}
                            </div>
                        </article>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default PharmuniAI;
